import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, Inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ApiConnectionDto, ApiConnectionVo, IAmqpApiConnectionOptionsConfig, IMongoDbApiConnectionOptionsConfig, IMsSqlApiConnectionOptionsConfig, ISftpApiConnectionOptionsConfig, FootPrintApiConnectionDto, FootPrintApiConnectionMetadataVo, FootPrintApiConnectionVo, FootPrintApiConnectionWorkflowsMetadataVo } from './api-connection.do';
import { DATEX_APP_API_URL } from './application.service';

@Injectable({
  providedIn: 'root'
})
export class ApiConnectionsService {

  protected endpointUrl: string;

  constructor(private http: HttpClient, @Inject(DATEX_APP_API_URL) private apiUrl: string) {
    this.endpointUrl = `${this.apiUrl}apiConnections`;
  }

  getApiConnections(apiConnectionTypeId: number = null, organizationId: number = null): Observable<ApiConnectionVo[]> {
    const url = `${this.endpointUrl}/?&apiConnectionTypeId=${apiConnectionTypeId ? apiConnectionTypeId : ''}&organizationId=${organizationId ? organizationId : ''}`;
    return this.http.get<ApiConnectionVo[]>(url);
  }

  getApiConnectionInfo(id: number): Observable<ApiConnectionVo> {
    const url = `${this.endpointUrl}/${id}/info`;
    return this.http.get<ApiConnectionVo>(url);
  }

  delete(id: number): Observable<void> {
    const url = `${this.endpointUrl}/${id}`;
    return this.http.delete<void>(url);
  }
}

@Injectable()
export abstract class ApiConnectionsBaseService<TDto extends ApiConnectionDto<any>> {
  protected endpointUrl: string;

  constructor(protected http: HttpClient, @Inject(DATEX_APP_API_URL) protected apiUrl: string, pathName: string) {
    this.endpointUrl = `${this.apiUrl}${pathName}ApiConnections`;
  }

  get(id: number): Observable<TDto> {
    const url = `${this.endpointUrl}/${id}`;
    return this.http.get<TDto>(url);
  }

  create(apiConnection: TDto): Observable<TDto> {
    return this.http.post<TDto>(this.endpointUrl, apiConnection);
  }

  update(apiConnection: TDto): Observable<TDto> {
    const url = `${this.endpointUrl}/${apiConnection.id}`;
    return this.http.put<TDto>(url, apiConnection);
  }

  delete(id: number): Observable<void> {
    const url = `${this.endpointUrl}/${id}`;
    return this.http.delete<void>(url);
  }
}

@Injectable({
  providedIn: 'root'
})
export class FootPrintApiConnectionsService extends ApiConnectionsBaseService<FootPrintApiConnectionDto> {

  constructor(http: HttpClient, @Inject(DATEX_APP_API_URL) apiUrl: string) {
    super(http, apiUrl, 'footPrint');
  }

  getApiConnectionInfo(id: number): Observable<FootPrintApiConnectionVo> {
    const url = `${this.endpointUrl}/${id}/info`;
    return this.http.get<FootPrintApiConnectionVo>(url);
  }

  getApiConnectionMetadataByName(name: string, applicationId: number): Observable<FootPrintApiConnectionMetadataVo> {
    const url = `${this.endpointUrl}/byName/${name}/metadata?applicationId=${applicationId}`;
    return this.http.get<FootPrintApiConnectionMetadataVo>(url);
  }

  getApiConnectionWorkflowsMetadataByName(name: string, applicationId: number): Observable<FootPrintApiConnectionWorkflowsMetadataVo> {
    const url = `${this.endpointUrl}/byName/${name}/workflowsMetadata?applicationId=${applicationId}`;
    return this.http.get<FootPrintApiConnectionWorkflowsMetadataVo>(url);
  }

  getIsWorkflowsMetadataNonUnique(applicationId: number): Observable<boolean> {
    const url = `${this.endpointUrl}/isWorkflowsMetadataNonUnique?applicationId=${applicationId}`;
    return this.http.get<boolean>(url);
  }

}

@Injectable({
  providedIn: 'root'
})
export class MongoDbApiConnectionsService extends ApiConnectionsBaseService<ApiConnectionDto<IMongoDbApiConnectionOptionsConfig>> {

  constructor(http: HttpClient, @Inject(DATEX_APP_API_URL) apiUrl: string) {
    super(http, apiUrl, 'mongoDb');
  }

}

@Injectable({
  providedIn: 'root'
})
export class AmqpApiConnectionsService extends ApiConnectionsBaseService<ApiConnectionDto<IAmqpApiConnectionOptionsConfig>> {

  constructor(http: HttpClient, @Inject(DATEX_APP_API_URL) apiUrl: string) {
    super(http, apiUrl, 'amqp');
  }

}

@Injectable({
  providedIn: 'root'
})
export class SftpApiConnectionsService extends ApiConnectionsBaseService<ApiConnectionDto<ISftpApiConnectionOptionsConfig>> {

  constructor(http: HttpClient, @Inject(DATEX_APP_API_URL) apiUrl: string) {
    super(http, apiUrl, 'sftp');
  }

}

@Injectable({
  providedIn: 'root'
})
export class TcpApiConnectionsService extends ApiConnectionsBaseService<ApiConnectionDto<ISftpApiConnectionOptionsConfig>> {

  constructor(http: HttpClient, @Inject(DATEX_APP_API_URL) apiUrl: string) {
    super(http, apiUrl, 'tcp');
  }

}

@Injectable({
  providedIn: 'root'
})
export class MsSqlApiConnectionsService extends ApiConnectionsBaseService<ApiConnectionDto<IMsSqlApiConnectionOptionsConfig>> {

  constructor(http: HttpClient, @Inject(DATEX_APP_API_URL) apiUrl: string) {
    super(http, apiUrl, 'mssql');
  }
}